import { render, staticRenderFns } from "./xjllb.vue?vue&type=template&id=8486a98a&scoped=true&"
import script from "./xjllb.vue?vue&type=script&lang=js&"
export * from "./xjllb.vue?vue&type=script&lang=js&"
import style0 from "./xjllb.vue?vue&type=style&index=0&id=8486a98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8486a98a",
  null
  
)

export default component.exports